// Copyright (c) Bentley Systems
import { SelectOption } from "@itwin/itwinui-react";
import { MatchCodeItem } from "./match-code-item";

export class EfieldOptions {
  public matchCodeId: number;
  public displayNull: boolean;
  public options: SelectOption<MatchCodeItem>[];

  constructor(
    matchCodeId: number,
    displayNull: boolean,
    options: SelectOption<MatchCodeItem>[],
  ) {
    this.matchCodeId = matchCodeId;
    this.displayNull = displayNull;
    this.options = options;
  }
}
